'use client';

import toast from 'react-hot-toast';
import type { CurrentUserHrContext } from '@/app/hr/components/types';

interface MeDocumentsTabProps {
  ctx: CurrentUserHrContext;
  resolveDocumentDownloadUrl: (storagePath: string) => Promise<string | null>;
}

const MeDocumentsTab = ({ ctx, resolveDocumentDownloadUrl }: MeDocumentsTabProps) => {
  if (ctx.documents.length === 0) {
    return (
      <div className="p-8 rounded-lg border border-dashed border-gray-200 text-center">
        <p className="text-[13px] font-semibold text-gray-600">No documents on file</p>
        <p className="text-[11px] text-gray-400 mt-1">Documents your HR team uploads (offer letters, certifications, etc.) will appear here.</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {ctx.documents.map(doc => (
        <div key={doc.id} className="flex items-center gap-3 rounded-lg border border-gray-200 bg-gray-50 p-3">
          <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0">
            <svg className="w-5 h-5 text-blue-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <path d="M14 2v6h6" />
            </svg>
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-[12px] font-semibold text-[#1C2E5E] truncate">{doc.display_name}</p>
            <div className="flex items-center gap-2 mt-0.5">
              <span className="text-[10px] text-gray-500 uppercase tracking-wide">{doc.document_type.replace(/_/g, ' ')}</span>
              {doc.expiration_date && (
                <span className={`text-[10px] font-bold ${new Date(doc.expiration_date).getTime() < Date.now() ? 'text-red-600' : 'text-gray-500'}`}>
                  Expires {new Date(doc.expiration_date).toLocaleDateString()}
                </span>
              )}
            </div>
          </div>
          <button
            type="button"
            onClick={async () => {
              const url = await resolveDocumentDownloadUrl(doc.storage_path);
              if (url) window.open(url, '_blank');
              else toast.error('Download failed');
            }}
            className="text-[#E89A3C] hover:underline text-[11px] font-semibold flex-shrink-0"
          >
            Download
          </button>
        </div>
      ))}
    </div>
  );
};

export default MeDocumentsTab;
